import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {
    HoverExpandButton, IconWrap, Label
} from "@dropDesk/presentation/components/buttons/button_expand_on_hover/styled";
import DropDeskIcon from "@dropDesk/storage/icons";
import {DropDeskIconType} from "@dropDesk/storage/icons/icons.d";
import React from "react";
import {SharedColors} from "@dropDesk/domain/entities/theme/app_colors";


export default function ButtonExpandOnHover(
    {
        icon,
        label,
        loading,
        onClick,
        style,
        sizeIcon,
        colorIcon,
        size,
        radius,
        styleIcon,
        backgroundColor,
        textColor
    }: {
        icon: DropDeskIconType,
        label: string,
        loading: boolean
        onClick: () => void
        style?: React.CSSProperties;
        sizeIcon: number
        colorIcon?: string
        size?: number
        radius?: number
        styleIcon?: React.CSSProperties;
        backgroundColor?: string
        textColor?: string
    }
) {
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;
    const color = textColor ?? colors.text;

    return (
        <HoverExpandButton
            type="button"
            disabled={loading}
            onClick={onClick}
            style={style}
            size={size}
            radius={radius}
            backgroundColor={backgroundColor ?? colors.onBackground}
            borderColor={colors.border}
        >
            <IconWrap size={size}>
                <DropDeskIcon icon={icon} size={sizeIcon} color={colorIcon ?? color}
                              style={{marginLeft: -3, ...styleIcon}}/>
            </IconWrap>
            <Label color={color}>{label}</Label>
        </HoverExpandButton>
    );
}
